//if (window.location.protocol != "https:") {
//	window.location.protocol = "https";
//}

import { Menu } from "./components/menu/component.js";

import { Page0_login } from "./components/page0_login/component.js";
import { Page1_tubes } from "./components/page1_tubes/component.js";
import { Page2_modems } from "./components/page2_modems/component.js";
import { Page3_users } from "./components/page3_users/component.js";
import { Page4_addmodem } from "./components/page4_addmodem/component.js";
import { Page5_notifications } from "./components/page5_notifications/component.js";
import { Page6_phones } from "./components/page6_phones/component.js";
import { OneWireData } from "./components/onewire/component";
import { Auth } from "./components/auth/component.js";

import { MainTemplate } from "./main-template.js";

import { i18n } from "./plugins/i18n.js";

import MainPlugin from "./plugins/main.js";
Vue.use(MainPlugin);
Vue.use(vFlagIcons);

const router = new VueRouter({
  routes: [
    {
      path: "/",
      redirect: "/Page1_tubes",
    },
    {
      path: "/Page1_tubes",
      component: Page1_tubes,
      name: "Трубы",
    },
    {
      path: "/Page2_modems",
      component: Page2_modems,
      name: "Модемы",
    },
    {
      path: "/Page3_users",
      component: Page3_users,
      name: "Пользователи",
    },
    {
      path: "/Page4_addmodem",
      component: Page4_addmodem,
      name: "Добавить модем",
    },
    {
      path: "/Page5_notifications",
      component: Page5_notifications,
      name: "Уведомления",
    },
    {
      path: "/Page6_phones",
      component: Page6_phones,
      name: "Список телефонов",
    },
    {
      path: "/OneWireData",
      component: OneWireData,
      name: "Данные OneWire",
    },
    {
      path: "/login",
      component: Page0_login,
      name: "Вход",
    },
  ],
});
Vue.config.devtools = true;
new Vue({
  el: "#app",
  components: {
    "menu-bar": Menu,
    auth: Auth,
  },
  i18n,
  router,
  template: MainTemplate,
  data: function () {
    return {
      logged: true,
      pu: i18n,
    };
  },
  mounted() {
    this.chechAuth();
    setInterval(this.chechAuth, globalConstants.loginRefreshInterval);
  },
  methods: {
    setLocale(locale) {
      var cont = this;
      this.$i18n.locale = locale;
    },
    chechAuth() {
      if (this.logged)
        // Если мы залогинены или первый запуск, проверяем авторизацию
        this.logged = this.$logged();
    },
    loginResult(result) {
      this.logged = result;
    },
  },
});



// WEBPACK FOOTER //
// ./src/app/js/main.js